import avatar1 from "../avatars/1.png";
import avatar2 from "../avatars/2.png";
import avatar3 from "../avatars/3.png";
import avatar4 from "../avatars/4.png";
import avatar5 from "../avatars/5.png";
import avatar6 from "../avatars/6.png";
import avatar7 from "../avatars/7.png";
import avatar8 from "../avatars/8.png";
import avatar9 from "../avatars/9.png";
import avatar10 from "../avatars/10.png";
import avatar11 from "../avatars/11.png";
import bg1 from "../images/shapes/93.jpg";
import bg2 from "../images/shapes/91.jpg";
import bg3 from "../images/shapes/26.jpg";
import bg4 from "../images/shapes/44.jpg";
import bg5 from "../images/shapes/213.png";
import me1 from "../images/WhatsApp Image 2022-10-28 at 6.44.09 PM.jpeg";
import me2 from "../images/ me.jpeg";
import dev from "../images/shapes/80.jpg";
import india from "../images/india.jpg";
const images = {
  avatar1,
  avatar2,
  avatar3,
  avatar4,
  avatar5,
  avatar6,
  avatar7,
  avatar8,
  avatar9,
  avatar10,
  avatar11,
  bg1,
  bg2,
  bg3,
  bg4,
  bg5,
  me1,
  me2,
  dev,
  india,
};

export default images;
